import { Column } from '@tempmee/react';
import { LabelValueDisplay } from '../LabelValueDisplay';

interface ISchedulePreviewProps {
  scheduleType: string;
  expectedDays: string;
}

export const SchedulePreview = ({ scheduleType, expectedDays }: ISchedulePreviewProps) => {
  return (
    <Column gap={4}>
      <LabelValueDisplay label="Schedule Type" value={scheduleType} />
      <LabelValueDisplay label="Expected Days" value={expectedDays} />
    </Column>
  );
};
